var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container w-full h-full"},_vm._l((_vm.waveformData),function(wave,i){return _c('div',{key:i,staticClass:"waveLine",style:({
        'background':(_vm.waveColor + "80"),
        'height': ((((200/_vm.waveformData.length)*(i) +(wave * 50 / _vm.waveMax))/3) + "%"),
        'width': ((((200/_vm.waveformData.length)*(i) + (wave * 50 / _vm.waveMax))/3) + "%"),
      })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }